import { pick } from 'lodash'
import { track } from './analytics'

const commonArgs = [
  'workspaceId',
  'workspaceSlug',
  'sourceId',
  'sourceSlug',
  'destinationSlug',
  'billingPlanId',
  'userId',
  'userEmail'
]

export const destinationErrorViewed = args => {
  track('Destination Error Viewed', pick(args, [...commonArgs, 'errorType']))
}

export const destinationErrorPayloadTabChanged = args => {
  track(
    'Destination Error Payload Tab Changed',
    pick(args, [...commonArgs, 'tabName'])
  )
}

export const destinationErrorPayloadCopied = args => {
  track(
    'Destination Error Payload Copied',
    pick(args, [...commonArgs, 'copiedPayload'])
  )
}

export const destinationEventDeliveryViewed = args => {
  track('Destination Deliverability Viewed', pick(args, commonArgs))
}

export const destinationEventDeliveryPeriodUpdated = args => {
  track(
    'Destination Deliverability Period Updated',
    pick(args, [...commonArgs, 'period'])
  )
}

export const destinationFeedbackSubmitted = args => {
  track('Destination Feedback Submitted', pick(args, ['url', 'feedbackText']))
}

export const destinationOverviewViewed = args => {
  track('Destination Overview Viewed', pick(args, commonArgs))
}

export const destinationOverviewSearchQuery = args => {
  track(
    'Destination Overview Searched',
    pick(args, [...commonArgs, 'searchQuery'])
  )
}

export const toggledErrorSummary = args => {
  track('Error Summary Toggled', pick(args, [...commonArgs, 'type']))
}

export const destinationOverviewPeriodUpdated = args => {
  track(
    'Destination Overview Period Updated',
    pick(args, [...commonArgs, 'period'])
  )
}
